<lib-search>
    <!-- <lib-events></lib-events> -->
    <lib-exhibit-carousel></lib-exhibit-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>    <!-- <lib-collections></lib-collections> -->
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-collection-multi-carousel></lib-collection-multi-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>

</lib-search>